module.exports = __webpack_public_path__ + "img/calendar.739c1d54.svg";